export enum FieldTypes {
  Measurement = 'Measurement',
}
